import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import { DisplayService } from './display.service';
import { RememberDeviceService } from './remember-device.service';

@Injectable({
  providedIn: 'root'
})
export class LdapService {

  constructor(
    private readonly http: HttpClient,
    private readonly displayService: DisplayService,
    private readonly rdService: RememberDeviceService
  ) { }

  public onPasswordLogin(password) {
    const postData = {
      password,
      deviceTag: true
    };
    this.rdService.checkAndApply(postData);
    return this.http.post(this.displayService.proxyUrl + 'factor/v1/PasswordAuthenticator', postData);
  }
}


